import { memo, useMemo } from 'react';
import c from 'classnames';
import times from 'lodash/times';

import { Box } from '@lyearn/ui';

import { CarouselProps } from '../../types';

type Props = Pick<CarouselProps, 'itemWidth' | 'renderSlide' | 'totalCount' | 'itemHeight'> & {
  className?: string;
};

const CarouselSlides = (props: Props) => {
  const { className, itemWidth, itemHeight, renderSlide, totalCount } = props;

  const style: React.CSSProperties = useMemo(() => {
    const baseStyle: React.CSSProperties = {};

    if (itemWidth === 'auto') {
      baseStyle.position = 'absolute';
      baseStyle.width = itemWidth;
    } else if (itemWidth) {
      baseStyle.maxWidth = itemWidth;
      baseStyle.minWidth = itemWidth;
    }

    if (itemHeight) {
      baseStyle.height = itemHeight;
      baseStyle.maxHeight = itemHeight;
    }

    return baseStyle;
  }, [itemWidth, itemHeight]);

  return (
    <>
      {times(totalCount, (index) => (
        <Box key={index} className={c('keen-slider__slide', className)} style={style}>
          {renderSlide(index)}
        </Box>
      ))}
    </>
  );
};

export default memo(CarouselSlides);
